import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=42b167e4&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=42b167e4&prod&lang=css"
import style1 from "./teacher.vue?vue&type=style&index=1&id=42b167e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b167e4",
  null
  
)

export default component.exports